// src/components/Header/Header.js
import React from 'react';
import './Header.css';

import trustLogo from '../../images/trustlogo-rightside-updated.png';
import collegeLogo from '../../images/lastlsdlogo-leftside.jpg';

const Header = () => {
  return (
    <header className="college-header">
      <div className="header-container">
        
        <div className="logo-section left">
           <img src={trustLogo} alt="Trust Logo" className="logo-image" />
        </div>

        <div className="title-section">
          <h1>Late Sanjay Tompe and Late Sameer Deshmukh B.Ed College of Education</h1>
          <h2>Chandur Bazar</h2>
          <p className="location">Chandur Bazar, Amravati</p>
          <p className="affiliation">( Affiliated by 2'S Sant Gadge Baba Amravati university,Amravati )</p>
          <p className="accreditation">NAAC Accredited by Grade B with CGPA 2.35 (1st cycle)</p>
          <p className="establishment">स्थापना २००८- २००९ | 2008-2009</p>
        </div>

        <div className="logo-section right">
           <img src={collegeLogo} alt="College Logo" className="logo-image" />
        </div>
      </div>
       <div className="donation-banner">
        Donation Exempt Under Section 80G of Income Tax Act
      </div>
    </header>
  );
};

export default Header;